// src/admin/components/common/PersonNameDisplay.jsx

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Displays a person's name in a stacked format:
 * - Given name on the first line
 * - Family name on the second line (muted)
 */
export default function PersonNameDisplay({
  givenName,
  familyName,
  fallback = '—',
  variant = 'stacked',
  email,
  companyName,
  className,
}) {
  const given = givenName?.trim() || '';
  const family = familyName?.trim() || '';

  if (variant === 'inline') {
    const text =
      [given, family].filter(Boolean).join(' ').trim() ||
      email?.trim() ||
      companyName?.trim() ||
      '';
    if (!text) {
      return <span className={classNames('text-muted', className)}>{fallback}</span>;
    }
    return <span className={className}>{text}</span>;
  }

  if (!given && !family) {
    return <span className={classNames('text-muted', className)}>{fallback}</span>;
  }

  return (
    <div className={classNames('d-flex flex-column', className)}>
      {given && <span>{given}</span>}
      {family && <small className="text-muted">{family}</small>}
    </div>
  );
}

PersonNameDisplay.propTypes = {
  givenName: PropTypes.string,
  familyName: PropTypes.string,
  fallback: PropTypes.string,
  variant: PropTypes.oneOf(['stacked', 'inline']),
  email: PropTypes.string,
  companyName: PropTypes.string,
  className: PropTypes.string,
};

